import React from "react";
import StarRating from "react-star-ratings";

function Rating({ rating = 0, starDimension = 15 }) {
  const separateRatings = () => {
    const rates = [];
    let temp = rating;
    for (let i = 0; i < 5; i++) {
      if (temp > 1) {
        rates.push(1);
        temp -= 1;
      } else {
        rates.push(temp);
        temp = 0;
      }
    }
    return rates.reverse();
  };

  const ratingsStatus = separateRatings();

  return ratingsStatus.map((rating, idx) => (
    <StarRating
      rating={rating*1}
      starEmptyColor="#ededed"
      starRatedColor="#FFCC00" 
      starDimension={starDimension}
      starSpacing={"1"}
      numberOfStars={1}
      key={idx}
    />
  ));
}

export default Rating;
